import { render, staticRenderFns } from "./SourcesAdmin.vue?vue&type=template&id=1105c51b&scoped=true"
import script from "./SourcesAdmin.vue?vue&type=script&lang=js"
export * from "./SourcesAdmin.vue?vue&type=script&lang=js"
import style0 from "./SourcesAdmin.vue?vue&type=style&index=0&id=1105c51b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1105c51b",
  null
  
)

export default component.exports